define('app-Search/main',['./modules/modules', './settings', 'util', 'moment'], function (modules, settings, util, moment) {
    return {

        jumbotronRow: null,

        searchControl: null,

        searchTabs: null,

        mobileSearchContainer: null,

        defaultSearchType: null,

        appendToJumbotronRow: function () {
            if ($(settings.jumbotronWithSearch).length <= 0)
                this.searchControl.appendTo(this.jumbotronRow);
            this.jumbotronRow.addClass('searchHero');
        },

        appendToGroupNav: function () {
            if ($(settings.groupNavWithSearch).length <= 0)
                this.searchControl.prependTo(this.mobileSearchContainer);
                $('#searchControl.searchCruise').show();
        },

        adjustHeight: function () {
            var searchTabs = $(settings.searchTabs);

            if ($(window).width() < 768) {


                this.searchControl.removeClass(this.defaultSearchType);
                this.appendToGroupNav();
                if ($('#editSearchButton').is(':visible')) {
                    $('.searchMobileButton').hide();
                }
                else if ($('#searchControl').attr('data-default-search-type') == "searchMaxiSR") {
                    if (!$('.leftNav').hasClass("popUpFilters")) {
                        $('.searchMobileButton').hide();
                        $('#editSearchButton, #filterResults').show();
                    }
                }
                else {
                    $('.searchMobileButton').show();
                }
            } else {

                //change to "searchMobile" or similar
                this.searchControl.addClass(this.defaultSearchType);

                switch (this.defaultSearchType) {
                    case "searchMini":
                        this.searchControl.find(".searchContent").css("display", "none");
                        this.searchControl.prependTo($(".breadcrumbList"));
                        this.searchControl.show();
                        break;
                    case "searchMaxi":
                        this.appendToJumbotronRow();
                        this.searchControl.show();
                        break;
                    case "searchMaxiSR":
                        this.searchControl.prependTo($("article"));
                        break;
                }

                this.searchControl.css("visibility", "visible");
            }

            if (this.searchControl.hasClass("searchMaxi") || this.searchControl.hasClass("searchMaxiSR")) {
                searchTabs.find("li.active > div").css("display", "block");
            }

            if (this.searchControl.hasClass("searchMaxiSR")) {
                this.searchControl.css({ 'visibility': 'visible', 'display': 'block' });
                var searchControlInner = this.searchControl.find(".searchControlInner").height();
                var searchContent = searchTabs.find("li.active .searchContent").height();
                $('.searchMobileButton').hide();

                if (searchContent < 200 && $(window).width() <= 1280) {
                    searchContent = searchContent + searchTabs.find("li.active").height() + 15;
                }

                this.searchControl.css("min-height", searchControlInner + searchContent + 45);
            }

            if (this.searchControl.hasClass("restoreSR") && $(settings.searchSummary).css("display") == "bslock") {
                this.searchControl.css("display", "none");
            }
        },

        loadNewStyleSearch: function () {
            var container = $(settings.container);

            if ($(window).width() >= 768) {
                this.appendToJumbotronRow();
                this.searchControl.show();
            }

            container.find(".searchSelect select").on("change", function () {
                var selected = $("#" + $(this).val());

                $("#searchTabs").find("li").removeClass('active keep');
                container.find(".searchContent").hide();
                selected.addClass('keep active');
                selected.find(".searchContent").show();
            });

            container.find(".destinationDuration").appendTo("#destinationSearchContent .firstLine");
            container.find(".hotelDuration").appendTo("#hotelSearchContent .firstLine");
            container.find(".tourDuration").appendTo("#tourSearchContent .firstLine");
            container.find(".ocDateField").prependTo("#oceanCruiseSearchContent .secondLine");
            container.find(".rcDateField").prependTo("#riverCruiseSearchContent .secondLine");
            container.find(".specialInterestPassengers").prependTo("#specialInterestSearchContent .secondLine");
            container.find(".soloTravellerDuration").appendTo("#soloTravellerSearchContent .firstLine");
        },

        showSummary: function (jsonData) {
            var container = $(settings.container);
            container.hide();

            // work out the summary text and write it to the div
            if (jsonData != "") {
                var holidayTypeTxt = "";
                    holidayTypeJson = "",
                    geographicTxt = "",
                    departurePointTxt = "",
                    departurePointJson = "",
                    cruiseLineTxt = "",
                    hostTxt = "",
                    dateTxt = "",
                    durationTxt = "",
                    passengersTxt = "",
                    passengerNumber = "",
                    jdata = new Array();

                for (key in jsonData) {
                    jdata[jsonData[key].type] = jsonData[key];
                }

                var tabtype = "destination";

                if (jdata["ht"] != undefined && jdata["ht"].description != undefined) {
                    tabtype = camelize(jdata["ht"].description.toLowerCase());

                    if (!(tabtype == "destination" || tabtype == "hotel" || tabtype == "tour" || tabtype == "riverCruise" || tabtype == "oceanCruise" || tabtype == "soloTraveller")) {
                        tabtype = "specialInterest";
                    }
                }

                for (key in jsonData) {
                    switch (jsonData[key].type) {
                        case "ht":
                            // could be more than one holiday type if multiple special interests are selected
                            var holidayTypePrefaceTxt = (holidayTypeTxt.length > 0) ? " or " : "";
                            var holidayTypePrefaceJson = (holidayTypeJson.length > 0) ? "|" : "";
                            holidayTypeTxt += holidayTypePrefaceTxt + jsonData[key].description;
                            holidayTypeJson += holidayTypePrefaceJson + jsonData[key].description;

                            break;

                        case "g":
                            geographicTxt = util.escape(jsonData[key].description);

                            var destinationField = (holidayTypeTxt == "") ? '#destinationSearchTxt' : '#hotelSearchTxt';

                            $(destinationField).val(geographicTxt);
                            $(destinationField + 'Query').val(geographicTxt);

                            break;
                        case "pc":
                            geographicTxt = util.escape(jsonData[key].description);

                            break;
                        case "c":
                            var cruiseLinePrefaceTxt = (cruiseLineTxt.length > 0) ? " or " : "";
                            cruiseLineTxt += cruiseLinePrefaceTxt + jsonData[key].description;

                            break;
                        case "dp":
                            var dpPrefaceTxt = (departurePointTxt.length > 0) ? " or " : "";
                            departurePointTxt += dpPrefaceTxt + jsonData[key].description;
                            var dpPrefaceJson = (departurePointJson.length > 0) ? "|" : "";
                            departurePointJson += dpPrefaceJson + jsonData[key].description;

                            break;
                        case "ho":
                            var aaHostPrefaceTxt = (hostTxt.length > 0) ? "|" : "";
                            var hostPrefaceTxt = (hostTxt.length > 0) ? " or " : "";
                            hostPrefaceTxt += hostPrefaceTxt + jsonData[key].description;
                            aaHostPrefaceTxt += aaHostPrefaceTxt + jsonData[key].description;
                            //hostTxt = jsonData[key].description;

                            break;
                        case "sd": //date - only need start date (sd) to get the month
                            var startDate = jsonData[key].value,
                                endDate = jdata["ed"].value,
                                travelStartDate = moment(startDate, "DD/MM/YYYY").format("YYYY-MM-DD"),
                                travelEndDate = moment(endDate, "DD/MM/YYYY").format("YYYY-MM-DD");

                            var mth = startDate.slice(3, 5);
                            var yyyy = startDate.slice(6, 10);
                            dateTxt = monthNames[mth - 1] + " " + yyyy;

                            availableDatesDictionary[dateTxt] = '{"type":"sd","value":"' + startDate + '"},{"type":"ed","value":"' + endDate + '"}';

                            var df = tabtype.replace("riverCruise", "rc").replace("oceanCruise", "oc").replace("specialInterest", "si");
                            $("#" + df + "DateField").val(dateTxt);
                            $('#facetDateField').val(dateTxt);

                            break;
                        case "du": //duration
                            durationTxt = (jsonData[key].value == "1-999") ? "any duration" : jsonData[key].value + " nights";

                            var mkey = encodeURIComponent('{"type":"du","value":"' + jsonData[key].value + '"}').toLowerCase();
                            $("#" + tabtype + "Duration").val(mkey);
                            $('#facetDuration').val(mkey);

                            break;
                        case "p":
                            passengerNumber = util.escape(jsonData[key].value);
                            passengersTxt = (passengerNumber == "1") ? passengerNumber + " passenger" : passengerNumber + " passengers";

                            var mkey = encodeURIComponent('{"type":"p","value":"' + passengerNumber + '"}').toLowerCase();
                            $("#" + tabtype + "Passengers").val(mkey);

                            break;
                    }
                }

                // destination
                var aaGeographicTxt = (geographicTxt == "") ? "all destinations" : geographicTxt;
                localStorage.setItem('destination', aaGeographicTxt);
                AdlAddUpdateItem('destination', aaGeographicTxt);

                // numberOfNights
                var aaDurationTxt = (durationTxt == "") ? "any duration" : durationTxt;
                localStorage.setItem('numberOfNights', aaDurationTxt);
                AdlAddUpdateItem('numberOfNights', aaDurationTxt);

                // carrierPreference
                var aaCarrierPreference = (cruiseLineTxt == "") ? "any carrier" : cruiseLineTxt;
                localStorage.setItem('carrierPreference', aaCarrierPreference);
                AdlAddUpdateItem('carrierPreference', aaCarrierPreference);

                // passengerNumber
                var aaPassengerNumber = (passengerNumber == "") ? "2" : passengerNumber;
                localStorage.setItem('passengerNumber', aaPassengerNumber);
                AdlAddUpdateItem('passengerNumber', aaPassengerNumber);

                // departurePoint
                var aaDeparturePointJson = (departurePointJson == "") ? "any departure point" : departurePointJson;
                localStorage.setItem('departurePoint', aaDeparturePointJson);
                AdlAddUpdateItem('departurePoint', aaDeparturePointJson);

                // departureDate
                var aaDateTxt = (dateTxt == "") ? "any dates" : dateTxt;
                localStorage.setItem('departureDate', aaDateTxt);
                AdlAddUpdateItem('departureDate', aaDateTxt);

                // hostList
                var aaHostTxtList = (typeof (aaHostPrefaceTxt) == "undefined") ? "any host" : aaHostPrefaceTxt;
                localStorage.setItem('hostList', aaHostTxtList);
                AdlAddUpdateItem('hostList', aaHostTxtList);

                // specialInterest
                // is dealt with in the code block to handle special interests generally (~line 252)

                // boardBasis - currently no option to set this so should always be 'any' at this stage
                var boardBasis = localStorage.getItem("boardBasis");

                if (!boardBasis) {
                    boardBasis = 'any board basis';
                    localStorage.setItem('boardBasis', boardBasis);
                }

                AdlAddUpdateItem('boardBasis', boardBasis);

                // Behavioural information
                //BHsearchResultsSeen
                localStorage.setItem('BHsearchResultsSeen', 'yes');
                AdlAddUpdateItem('BHsearchResultsSeen', 'yes');

                //BHsearchResultsAction
                localStorage.setItem('BHsearchResultsAction', '');
                AdlAddUpdateItem('BHsearchResultsAction', '');

                //BHsearchMethodWidgetType
                localStorage.setItem('BHsearchMethodWidgetType', '');
                AdlAddUpdateItem('BHsearchMethodWidgetType', '');

                //BHsearchMethodLinkType
                localStorage.setItem('BHsearchMethodLinkType', '');
                AdlAddUpdateItem('BHsearchMethodLinkType', '');

                //BHsearchMethodPagePosition
                localStorage.setItem('BHsearchMethodPagePosition', '');
                AdlAddUpdateItem('BHsearchMethodPagePosition', '');

                //BHsearchMethodPageType
                localStorage.setItem('BHsearchMethodPageType', '');
                AdlAddUpdateItem('BHsearchMethodPageType', '');

                // -------------------------------------------------------

                // Add to ADL  AdlAddUpdateItem(adUpKey, adUpValue)
                // to do: AdlAddUpdateItem('searchResults', '{{"' + number + '"}}'); - ln 28 in \app-SearchResults\modules\batBelt\viewModel
                AdlAddUpdateItem('searchTerm', geographicTxt);
                AdlAddUpdateItem('searchTravelDate', dateTxt);
                AdlAddUpdateItem('searchTravelDuration', durationTxt);
                AdlAddUpdateItem('searchPassengerNumber', passengersTxt);
                AdlAddUpdateItem('searchDeparturePoint', departurePointJson);
                AdlAddUpdateItem('searchRegion', geographicTxt);
                AdlAddUpdateItem('searchControlsearchCruiseLine', cruiseLineTxt);
                AdlAddUpdateItem('metaTravelStartDate', travelStartDate !== undefined ? travelStartDate : moment().format('YYYY-MM-DD'));
                AdlAddUpdateItem('metaTravelEndDate', travelEndDate !== undefined ? travelEndDate : moment().add(4, 'year').format('YYYY-MM-DD'));

                // Special Interests actually come through as search type, but we can determine if it was a SI search and populate this variable 
                if (tabtype == "specialInterest") {
                    AdlAddUpdateItem('searchType', 'Special Interest');
                    AdlAddUpdateItem('searchInterestType', holidayTypeJson);
                    localStorage.setItem('specialInterest', holidayTypeJson);
                    AdlAddUpdateItem('specialInterest', holidayTypeJson);
                } else {
                    AdlAddUpdateItem('searchType', holidayTypeTxt);
                    AdlAddUpdateItem('searchInterestType', '');
                    localStorage.setItem('specialInterest', 'any interest');
                    AdlAddUpdateItem('specialInterest', 'any interest');
                };

                var htSuffix = (holidayTypeTxt.toLowerCase() == "ocean cruise" || holidayTypeTxt.toLowerCase() == "river cruise") ? "s" : " holidays";
                var searchSummaryStr = "You searched for ";
                searchSummaryStr += (geographicTxt + departurePointTxt + dateTxt + durationTxt == "") ? "<span> all " : "<span>";
                searchSummaryStr += (holidayTypeTxt == "") ? " holidays and cruises</span> " : holidayTypeTxt + htSuffix + "</span>";
                searchSummaryStr += (hostTxt != "") ? " hosted by <span>" + hostTxt + "</span> " : "";
                searchSummaryStr += (cruiseLineTxt != "") ? " with <span>" + cruiseLineTxt + "</span>" : "";
                searchSummaryStr += (geographicTxt != "") ? " to <span>" + geographicTxt + "</span>" : "";
                searchSummaryStr += (passengersTxt != "") ? " for <span>" + passengersTxt + "</span>" : "";
                searchSummaryStr += (departurePointTxt != "") ? " departing from <span>" + departurePointTxt + "</span>" : "";
                searchSummaryStr += (dateTxt != "") ? " in <span>" + dateTxt + "</span>" : "";
                searchSummaryStr += (durationTxt != "") ? " for <span>" + durationTxt + "</span>" : "";
                searchSummaryStr += '<span style="width:20px;display:inline-block"></span>';

                $('#searchBreadcrumb').prepend(searchSummaryStr);
            }
        },

        run: function () {
            var $thisModule = this;
            this.searchControl = $(settings.container);
            this.mobileSearchContainer = $('#searchMobile');
            this.defaultSearchType = $thisModule.searchControl.data('default-search-type');
            this.searchTabs = $(settings.searchTabs);

            if (this.searchControl.length === 0) {
                window.log("No SEARCH CONTROL container located. Search will not be available");
                return;
            }

            window.log("Loading app-Search.");

            this.jumbotronRow = $('.jumbotron__container .row').first();
            var searchSummary = $(settings.searchSummary);
            var searchTabs = $(settings.searchTabs);
            var jsonData = "";
            var hashData = $(location).attr("hash");

            if (this.searchControl.hasClass("newStyleSearch")) {
                $thisModule.loadNewStyleSearch();
            } else if (this.searchControl.hasClass("searchMaxi") || this.searchControl.hasClass("searchMaxiSR")) {
                $('.slider .blurOverlay').hide();
            }

             

            // add tab click behaviour
            searchTabs.children("li").children("a").on("click", function (e) {
                e.preventDefault();

                var $this = $(this);
                var parent = $this.parent();

                if ($thisModule.searchControl.hasClass("searchMini")) {
                    if (parent.hasClass("active")) {
                        parent.find(".searchContent").css("display", "none");
                        parent.removeClass("active");
                    } else {
                        parent.find(".searchContent").css("display", "block");
                        parent.addClass("active");
                    }
                } else {
                    searchTabs.find("li").removeClass("active");
                    searchTabs.find("li > div").css("display", "none");

                    $this.next().css("display", "block");
                    parent.addClass("active");

                    AdlAddUpdateItem('editSearchType', $this.find('.tabName').text());
                }
            });

            

            // add cruise filter behaviour
            $(".cruiseOptionFilterSelect").on("change", function (e) {
                e.preventDefault();

                var current = $(this).val();
                var parent = $("#" + current);

                searchTabs.removeClass("disabled");
                searchTabs.find("li").removeClass("active");
                parent.addClass("active");

                AdlAddUpdateItem('editSearchType', current);

            });

            $("#searchTabs").on("click", function (e) {
                if ($(this).hasClass('disabled')) {
                    $('.cruiseOptionFilter').addClass('focus');
                }
            });
            $(".cruiseOptionFilter").on("click", function (e) {
                $(this).removeClass('focus');
            });

            

            $(".cruiseMiniSearch").on("click", function (e) {
                e.preventDefault();
                $('#searchControl').toggleClass('miniSearchOpen');
                $('#searchControl.searchCruise').find('.searchContent').css('display', 'flex');
                $(this).toggleClass('active');

                if ($(window).width() < 768) {
                    if ($(this).hasClass('active')) {
                        var SearchHeight = $('#searchControl').height();
                        var heroHeight = $('.bx-wrapper').height();
                        if (SearchHeight > heroHeight) {
                            $('#newMiniSearch').css({ 'margin-top': SearchHeight - heroHeight + 20 + 'px' });
                        }
                    }
                    else {
                        $('#newMiniSearch').css({ 'margin-top': 0 + 'px' });
                    }
                }
            });
            


            // resize tabs for mobile
            $(window).resize(function () {

                if (!$('body').hasClass('cruise')) {
                    $thisModule.adjustHeight();
                }
                

                this.searchControl = $(settings.container);

                if (this.searchControl.hasClass("searchMaxiSR")) {
                    var searchControlli = searchTabs.find("li.active").height();
                    var searchContent = searchTabs.find("li.active .searchContent").height();
                    this.searchControl.css("min-height", searchControlli + searchContent + 45);
                    console.log("resize");
                    console.log(searchContent);

                    console.log(searchControlli);
                }
                if (this.searchControl.hasClass("searchResultsBar")) {
                    
                        if ($(window).width() < 992) {
                            if (!$('.cruiseMiniSearch').hasClass('active')) {
                                this.searchControl.removeClass('miniSearchOpen');
                                this.searchControl.hide();
                            }
                        }
                        else {
                            this.searchControl.addClass('miniSearchOpen');
                        }
                        
                    
                }

            });
            
            $("#search-select").change(function (val) {
                $("#searchTabs li").removeClass("active");
                var tab = "#" + $("#search-select option:selected").val();
                $(tab).addClass("active");
                $(tab + " .searchContent").show();
            });

            // get search data from url
            if (hashData != "") {
                var startAt = hashData.indexOf('[');

                if (startAt >= 0) {
                    var endAt = hashData.lastIndexOf(']');
                    var searchTagsRaw = hashData.substring(startAt, endAt + 1);
                    var searchTags = decodeURIComponent(searchTagsRaw);

                    if (searchTags != "") {
                        jsonData = JSON.parse(searchTags);
                    }
                }
            }

            //if this is a search results page - don't load the search control - show the 'search summary'  instead
            var path = window.location.pathname.toLowerCase().replace(".aspx", "");
            if (path === "/search" || path === "/cruises/search") {
                $thisModule.showSummary(jsonData);
            }

            var holidayType = resources_getObjects(jsonData, "type", "ht");

            // if required (value exists in pagehash) - open appropriate tab and set options to selections
            if (holidayType.length > 0 && holidayType[0].description) {

                if (window.location.pathname.toLowerCase().replace(".aspx", "") === "/cruises/search") {
                    switch (holidayType[0].description) {
                        case "River Cruise":
                            $('.cruiseOptionFilterSelect').val("searchTab5").change();
                            break;
                        case "Ocean Cruise":
                            $('.cruiseOptionFilterSelect').val("searchTab4").change();
                            break;
                    }
                }

                var holidayDescription = holidayType[0].description.slice(0, 3);

                // solo travellers tab is called singles holidays - change sol --> sin to accomodate this
                if (holidayDescription.toLowerCase() === "sol") {
                    holidayDescription = "Sin";
                }

                var tabLabel = this.searchControl.find('.tabLabel:contains("' + holidayDescription + '")').first();

                // default to 'destination'
                if (tabLabel.length) {
                    tabLabel.trigger("click");
                } else {
                    this.searchControl.find(".tabLabel:contains('Dest')").first().trigger("click");
                }
            }

            $("#facetDateField").off("focus");
            this.searchControl.find(".searchSelect select").val(searchTabs.find("li.active").attr("id"));

            //Hide date dropwdown when other selects clicked 
            $(".searchCruise select").on("click", function (e) {
                if ($('.dateFieldPicker').is(':visible')) {
                    $('.dateFieldPicker').slideToggle();
                    $('.dateFieldPicker').blur();
                    $('.dateDropdown').removeClass("activeDropdown");

                } 
            });

                      

            // Initialise each module.
            modules.forEach(function (module) {
                if (module.target === undefined || (module.target !== undefined && module.target.length)) {
                    module.run(settings);
                }
            });
            if ($(this).hasClass('disabled')) {
                $('.cruiseOptionFilter').addClass('focus');
            }

            if (!$('body').hasClass('cruise')) {
                $thisModule.adjustHeight();
            } else {
                if ($(window).width() > 991) {
                    $("#searchControl").show();
                }
            }


            if ($("#cruise-product").length) {
                $(".cruiseUtility .cruiseMiniSearch").show();  
            }
            


        }


    }
});
